import OfferIcon from './OfferIcon';
export default OfferIcon;
